import React from 'react';
import { TabsV1, TabsV2 } from './ui';
import { APIProductTypes } from 'app/api/APITypes';

export enum TabsTheme {
    V1 = 'V1',
    V2 = 'V2',
}

interface IHistoryTabs {
    name: string,
    value: 'income' | 'outcome' | 'moneybox',
};

interface TabsProps {
    type: TabsTheme,
    theme: 'history' | 'shop',
    cb: any,
    historyTabs?: IHistoryTabs[],
    shopTabs?: { name: string, filter?: APIProductTypes }[],
};

export const Tabs = ({ type, theme, cb, historyTabs, shopTabs }: TabsProps) => {
    return (
        <>
            {
                type === 'V1' && <TabsV1 type={theme} historyTabs={historyTabs} shopTabs={shopTabs} callBackFunc={cb} />
            }
            {/* {
                type === 'V2' && <TabsV2 type={theme} historyTabs={historyTabs} shopTabs={shopTabs} callBackFunc={cb} />
            } */}
        </>
    );
};
